module.exports = __webpack_public_path__ + "cbbfcdaf8ad7806776f50cf3c160d120.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/chechout_from_shelf.png
// module id = 171
// module chunks = 0